<template>

    <div class="d-flex justify-content-start">
        <span class="">
            {{ label }}
        </span>
        <span class="ms-3">
            <inertia-link :href="'?sort=' + column + '&direction=desc'" :class="{'text-dark': filters.sort === column && filters.direction === 'desc'}">
                <i class="bi bi-chevron-down"></i>
            </inertia-link>
            <inertia-link :href="'?sort=' + column + '&direction=asc'" :class="{'text-dark': filters.sort === column && filters.direction === 'asc'}">
                <i class="bi bi-chevron-up"></i>
            </inertia-link>
        </span>
    </div>

</template>

<script>
    export default {
        props: [
            'label',
            'column',
            'filters',
        ],
        data() {
            return {
            }
        },
        components: {
        },
        methods: {
        },
    }
</script>
